<template>
    <div id="assignments-table">
        <div class="overlay" v-if="supervisorComments" @click.prevent="supervisorComments = null">
            <div class="comments-wrapper" @click.stop>
                <i class="fa fa-close" @click="supervisorComments = null"></i>
                <div v-for="(comments, date) in supervisorComments" :key="date" class="comment-group">
                    <h3>{{date}}</h3>
                    <ul>
                        <li v-for="(comment, $index) in comments[0]" :key="$index" v-html="comment"></li>
                    </ul>
                </div>
                
            </div>
        
        </div>
        <v-client-table v-if="assignmentData && columns && currentTerm" :options="tableOptions" :data="assignmentData" :columns="columns" ref="assignmentsTable">
            <template slot="week" scope="props">
                <div @click.prevent="toggleChild(props.row.id)">
                    Week {{props.row.week}}
                </div>
            </template>
            <template slot="name" scope="props">
                <div class="nowrap" @click.prevent="toggleChild(props.row.id)">
                    {{props.row.name.substring(0, 24)}}{{props.row.name.length > 24 ? "..." : ""}}
                </div>
            </template>
            <template slot="courseName" scope="props">
                <div v-if="props.row.video">
                    {{props.row.video.course.name}}
                </div>
            </template>
            <template slot="dueDate" scope="props">
                {{props.row.dueDate | localDate}}
                <i 
                        class="fa fa-comments cursor-pointer" 
                        v-if="hasSupervisorComments(props.row.submissions)" 
                        title="Supervisor comments"
                        @click.prevent="showSupervisorComments(props.row.submissions)"></i>
            </template>
            <template slot="submit" scope="props">
                <div>
                    <a href="#"
                        @click.prevent="toggleChild(props.row.id)">
                        <span class="submit"
                            v-if="(!props.row.submissions || props.row.submissions.length < 1)
                            && !isPastDue(props.row.dueDate)">Submit</span>

                        <span class="overdue"
                            v-if="(!props.row.submissions ||  props.row.submissions.length < 1 )
                            && isPastDue(props.row.dueDate)">Submit (Past Due)</span>

                        <span class="resubmit"
                            v-if="props.row.submissions && props.row.submissions.length > 0
                            && !isPastDue(props.row.dueDate)">Resubmit</span>

                        <span class="submitted"
                            v-if="props.row.submissions && props.row.submissions.length > 0
                            && isPastDue(props.row.dueDate)">Submitted</span>
                    </a>
                </div>
            </template>
            <template slot="grade" scope="props">
                <div class="grade nowrap" v-if="props.row.submissions && props.row.submissions.length > 0 && props.row.submissions[0].grade">
                    {{props.row.submissions[0].grade}} %                    
                </div>
            </template>
            <template slot="feedback" scope="props">

                <div class="assignment-play" v-if="assignmentsLoaded">
                    <img v-if="
                        props.row.submissions &&
                        props.row.submissions.length > 0
                        && props.row.feedback"
                        @click="playFeedback(props.row, true)" src="../../../assets/img/play-button-small-green.png">
                    <img v-else class="inactive" src="../../../assets/img/play-button-small-grey.png">
                </div>
            </template>
        </v-client-table>
        <div class="feedback-lightbox" @click="stopFeedback()" v-show="feedbackPlaying===true">
            <i class="fa fa-remove"></i>
            <div class="video-wrapper" @click.stop>
                <poly-video
                    ref="videoPlayer"
                    :vjsOptions="videoPlayerOptions"
                    :sources="videoPlayerSources"
                    @error="onVideoPlayerError"
                    @loadedsource="onVideoPlayerLoadedSource">
                </poly-video>
            </div>
        </div>
    </div>
</template>
<script>
    import aws from '../../../services/aws';
    import users from '../../../services/users';
    import assignments from '../../../services/assignments';
    import submissions from '../../../services/submissions';
    import child from './templates/Child.vue';
    import PolyVideo from '../poly-video';
    import toastr from 'toastr';
    import moment from 'moment';

    export default {
        props: ['currentWeek', 'assignments','selectedCourseSet'],
        data() {
            return {
                assignmentsLoaded: true,
                studentAssignments: null,
                assignmentData: null,
                termMarks: null,
                columns: null,
                supervisorComments: null,
                tableOptions: {
                    childRow: child,
                    perPage: 1000,
                    headings: {
                        courseName: 'Course Name',
                        dueDate: 'Due Date'
                    },
                    texts: {
                        count: ''
                    }
                },
                feedbackLoading: false,
                feedbackPlaying: false,
                videoPlayerSources: [],
                videoPlayerOptions: { fluid: true },
            }
        },
        components: {
            PolyVideo,
        },

        async mounted() {
            var self = this;

            if (this.assignments && this.$route.name === ('course')) {
                this.studentAssignments = this.assignments;
                this.assignmentData = this.studentAssignments.filter(function(a) { return new Date(a.availableDate) <= moment().tz('America/Vancouver').toDate(); });
            } else {
                if (this.$store.getters.courses) {
                    this.getAssignments();
                }
            }

            let columns = ['week', 'name', 'dueDate', 'submit', 'grade', 'feedback'];

            if (this.$route.name !== 'course') {
                columns.splice(2, 0, 'courseName');
            }

            this.columns = columns;

            self.$bus.$on('reload_assignment', function() {
                self.getAssignments();
            });

            this.$bus.$on('playFeedback', function(url) {
                self.playFeedback(url);
            });

            if (this.$route.query.assignment) {
                $('html, body').animate({ scrollTop: $('#assignments-table').offset().top }, 2000);

                this.$nextTick(function() {
                    self.toggleChild(self.$route.query.assignment)
                });
            }

        },
        watch: {
            '$store.getters.courses'() {
                this.getAssignments();
            },
            '$store.getters.currentTerm': {
                handler(term) {
                    if (this.studentAssignments) {
                        this.assignmentData = this.studentAssignments.filter(function(a) {
                            
                            if (!a.video) return true;

                            return !a.video.course.courseSets || a.video.course.courseSets.length === 0 || a.video.course.courseSets.includes(term.selectedCourseSet);
                        });
                    }
                },
                deep: true
            }

        },
        methods: {
            hasSupervisorComments(submissions) {
                return submissions.some(s => s.supervisorComments && s.supervisorComments.length);
            },
            showSupervisorComments(submissions) {
                const supervisorComments = submissions.map((s)=>{
                    return {
                        date: s.createdAt,
                        comments: s.supervisorComments                    
                    }
                }).filter((s)=>{
                    return s.comments && s.comments.length > 0;                
                });
                const groupedByDate = supervisorComments.reduce((group, comment) => {
                    const date = new Date(comment.date).toLocaleDateString();
                    if (!group[date]) {
                        group[date] = [];
                    }
                    group[date].push(comment.comments);
                    return group;
                }, {});

                this.supervisorComments = groupedByDate;

            },
            playFeedback(data, findLatest) {
                let url;

                if (findLatest === true) {
                    const submissions = data.submissions.filter(s => s.feedback).sort((a,b)=>{
                        return new Date(b.createdAt) > new Date(a.createdAt)
                    });

                    url = submissions[0].feedback.body;
                } else {
                    url = data;
                }

                const isVideoUrlDiff = () => {
                    if (this.videoPlayerSources.length === 0) {
                        return true;
                    }
                    return this.videoPlayerSources[0] !== url;
                };

                if (isVideoUrlDiff()) {
                    this.feedbackLoading = true;
                    this.$store.dispatch('toggle', {
                        type: 'loading',
                        boolean: true,
                    });
                    this.videoPlayerSources = [url];
                }

                this.feedbackPlaying = true;
            },
            stopFeedback() {
                this.$refs.videoPlayer.getVjsPlayer().pause();
                this.feedbackPlaying = false;
            },
            onVideoPlayerLoadedSource() {
                if (this.feedbackLoading) {
                    this.feedbackLoading = false;
                    this.feedbackPlaying = true;
                    this.$store.dispatch('toggle', {
                        type: 'loading',
                        boolean: false,
                    });
                }
            },
            onVideoPlayerError() {
                if (this.feedbackLoading) {
                    this.feedbackLoading = false;
                    this.$store.dispatch('toggle', {
                        type: 'loading',
                        boolean: false,
                    });
                    toastr.error('Error getting feedback video');
                }
            },

            isPastDue(d) {
                return new Date(d) < new Date();
            },
            toggleChild(id) {
                this.$refs.assignmentsTable.toggleChildRow(id);
            },
            async getMarks() {
                const marksData = await users.getMarks(localStorage.user_id);
                if (marksData.data.metrics) {                   
                    const marks = marksData.data.metrics;
                    const termMarks = marks.find(m => m.termId === this.currentTerm.id);
                    if (termMarks && termMarks.marks.assignments) {                                                
                        this.termMarks = termMarks.marks.assignments.assignments;
                    }

                }

            },
            async getAssignments() {
                await this.getMarks();

                var self = this;
                let assignments = this.$store.getters.courses.map(function(c) { return c.assignments });

                assignments = [].concat.apply([], assignments).sort(function(a, b) { return a.week - b.week });
                assignments = assignments.filter(function(a) { return new Date(a.availableDate) <= moment().tz('America/Vancouver').toDate(); });
                let assignmentIds = assignments.map(function(a) { return a.id });
                if (assignmentIds.length === 0) return;

                assignments.forEach(function(a) { a.submissions = []; });

                submissions.getMine(this, assignmentIds).then(function(response) {
                    response.data.submissions.forEach(function(submission) {


                        let index = assignments.findIndex(function(a) { return a.id == submission.assignmentId })
                        if (index > -1) {
                            assignments[index].submissions.push(submission);
                            let feedback = assignments[index].submissions.filter(function(s) {
                                return s.feedback;
                            });

                            if (feedback.length > 0) {
                                feedback = feedback.sort(function(a, b) {
                                    return a.feedback.createdAt - b.feedback.createdAt;
                                })[0].feedback.body;

                                assignments[index].feedback = feedback;
                            }

                            assignments[index].submissions = assignments[index].submissions.sort(function(a, b) {
                                return ((a.feedback === null) || (b.feedback === null)) ||
                                +(new Date(a.feedback.createdAt) < new Date(b.feedback.createdAt)) ||
                                      -(new Date(a.feedback.createdAt) > new Date(b.feedback.createdAt));
                            }).sort(function(a, b) {
                                return (a.grade === null) - (b.grade === null) || -(parseInt(a.grade) > parseInt(b.grade)) || +(parseInt(a.grade) < parseInt(b.grade));
                            });                            
                        }
                    });

                    if (self.termMarks) {
                        for (const assignment of assignments) {
                            const markedAssignment = self.termMarks.find(m => m.submission && m.submission.assignmentId === assignment.id);
                            
                            if (markedAssignment) {                                                      
                                assignment.submissions[0].grade = markedAssignment.submission.grade;                                  
                            }                           

                        }
                    }

                    self.studentAssignments = assignments;
                    self.assignmentData = assignments;
                    if (self.currentTerm.selectedCourseSet) {
                        self.assignmentData = self.studentAssignments.filter(function(a) {
                            
                            if (!a.video) return true;

                            return !a.video.course.courseSets || a.video.course.courseSets.length === 0 || a.video.course.courseSets.includes(self.currentTerm.selectedCourseSet);
                        });
                    }
                });

            },

        },
        computed: {
            currentTerm() {
                return this.$store.getters.currentTerm;
            },
        }


    }

</script>
<style lang="scss" scoped>
    .submitted {
        background: #3ac384;
        color: black !important;
    }

    .overdue {
        background: #c33a44;
    }

    .submit {
        background: #33ccff;
        color: black !important;
    }

    .resubmit {
        background: #16576d;
        color: white !important;
    }


    section.course .grade {
        height: 4rem;
        line-height: 4rem;
        padding-left: 1rem;
    }

</style>
<style lang="scss">
.assignments {
    tr td:nth-child(1) {
        width: 4%;
    }
    tr td:nth-child(2) {
        width: 8%;
    }
    tr td:nth-child(3) {
        width: 20%;
    }
    tr td:nth-child(4) {
        width: 20%;
    }
    tr td:nth-child(5) {
        width: 20%;
    }
    tr td:nth-child(6) {
        width: 13%;
    }
}
    .VueTables__limit {
        display: none !important;
    }

    section.course .VueTables__table tbody tr {
        td:nth-child(5) {
            padding: 0;

            span {
                color: #fff;
                padding: 8px;
                padding-bottom: 13px;
                margin: 0;
                width: 100%;
                height: 100%;
                display: block;
                overflow: auto;
            }
        }

        td:nth-child(7) {
            padding: 2px 0 0 0;
        }
    }

    .VueTables__table tbody tr {

        //height: 200px;
        td:nth-child(6) {
            padding: 0px;

            span {
                color: #fff;
                padding: 8px;
                padding-bottom: 13px;
                margin: 0 !important;
                width: 100%;
                height: 150% !important;
                display: block;
            }
        }

        td:nth-child(8) {
            padding: 2px 0 0 0;
        }
    }

    .VueTables__child-row-toggler {
        width: 22px;
        height: 22px;
        line-height: 22px;
        display: block;
        margin: auto;
        text-align: center;
        font-size: 2rem;
        color: #fff;
        position: relative;
        top: 0px;
        font-weight: bold;
        cursor: pointer;
    }

    .VueTables__child-row-toggler--closed::before {
        content: "+";
    }

    .VueTables__child-row-toggler--open::before {
        content: "-";
    }

    .VueTables {
        a {
            overflow: auto;
            height: 100%;
        }

        td,
        a {
            color: #fff;
        }

        .this-week {

            td,
            a {
                color: #161616;
            }
        }
    }

    label {
        font-weight: 100 !important;
        position: relative;
        top: 3px;
    }

    .feedback-lightbox {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99999;
        background: rgba(0, 0, 0, .7);
        display: flex;
        align-items: center;
        justify-content: center;

        .video-wrapper {
            width: 800px;
            max-width: 100%;
        }

        i.fa-remove {
            position: absolute;
            top: 1rem;
            right: 1rem;
            color: #fff;
            font-size: 3rem;
            cursor: pointer;
        }
    }

    .assignment-play {
        cursor: pointer;
        margin: 0 auto;
        text-align: center;

        img {
            width: 35px;
            height: 35px;
            position: relative;
            left: -4px;

            &.inactive {
                cursor: default;
            }
        }

    }
    .fa-comments {
        color: #3cf;
    }

    .grade {
        
        //display:inline-block;
        //padding:8px;
    }
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index:9999999;
        .comments-wrapper {
            background: #2a2a2a;
            border-radius: 8px;
            border-top: 3px solid #33ccff;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
            padding: 2rem;
            width: 80%;
            max-width: 600px;
            max-height: 80%;
            overflow-y: auto;
            position: relative;

            .fa-close {
                position: absolute;
                top: 1rem;
                right: 1rem;
                color: #888;
                font-size: 1.6rem;
                cursor: pointer;
                transition: color 0.15s ease;
                &:hover {
                    color: #fff;
                }
            }

            .comment-group {
                margin-bottom: 1.5rem;
                padding-bottom: 1.5rem;
                border-bottom: 1px solid #3a3a3a;

                &:last-child {
                    border-bottom: none;
                    margin-bottom: 0;
                    padding-bottom: 0;
                }

                h3 {
                    margin-bottom: .75rem;
                    font-size: 14px;
                    text-transform: uppercase;
                    letter-spacing: 0.05em;
                    color: #33ccff;
                    font-weight: 600;
                }

                li {
                    margin-bottom: 1rem;
                    line-height: 1.6;
                    color: #ccc;
                }
            }

            button {
                color: #fff;
                border: none;
                padding: .5rem 1rem;
                cursor: pointer;
                display: block;
                margin-left: auto;
            }
        }

    }
    .nowrap {
        white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// AssignmentsTable.vue?98075134